module.exports = __webpack_public_path__ + "staticesp/media/minirobo.de26b4ed.mp4";